import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api
import {
    getListObjects,
    createObject,
    deleteObject,
    updateObjectById,
    getListObjectQuerybyid,
    getListObjectsByName
} from '../../services/apis/ObjectAPIServices'
import { uploadAvatar } from '../../services/apis/UserAPIServices'
import { message } from 'antd'
import { HandleErrorCode } from '../handleErrorCode/index'
const imageToBase64 = require('image-to-base64');


function* saga_LoadListObjects(action) {
    try {
        const { params } = action.payload

        let page_number = yield select(state => state.object.pageIndex)
        let page_size = yield select(state => state.object.pageSize)
        let status = yield select(state => state.object._status)
        let textSearch = yield select(state => state.object.lastTextSearch)
        let begin_time = yield select(state => state.object.begin_time)
        let end_time = yield select(state => state.object.end_time)
        let type_search = yield select(state => state.object.type_search)

        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size
        if (params.status != null) status = params.status

        const response = yield call(
            getListObjects,
            page_number,
            page_size,
            status,
            (textSearch),
            begin_time,
            end_time,
            type_search
        )

        if (response.error.code === 200) {
            let objects = response.data
            let total = response.total

            if (objects.length > page_size)
                objects = objects.slice(0, page_size)

            yield put(actions.action.loadListObjectsSuccess(objects))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                    pageIndex: page_number,
                })
            )
        } else {
            console.error(
                'Get list object call API  server error: ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('get list object error : ', ex.messag)
    }
}

function* saga_SaveCurrentObject(action) {
    try {
        const { extendData } = action.payload
        let currentObject = yield select(state => state.object.currentObject)
        let ListCurrentMedia = yield select(state => state.scrumBoard.ListCurrentMedia)
        let ListCurrentEvent = yield select(state => state.scrumBoard.ListCurrentEvent)
        let event_id = []
        let media_id = []
        ListCurrentMedia.map(vl => {
            media_id.push(vl.media_id)
        })
        ListCurrentEvent.map(vl => {
            event_id.push(vl.event_id)
        })
        console.log('event_id', event_id + media_id)
        currentObject = {
            ...currentObject,
            ...{
                ext_data: { lstExtendData: JSON.stringify(extendData), media_ids: JSON.stringify(media_id), event_ids: JSON.stringify(event_id) }
            },
        }
        const avatar_file = yield select(state => state.object.avatar_file)

        // upload avatar
        try {
            if (avatar_file != null) {
                const responseUploadAvatar = yield uploadAvatar(avatar_file)
                const avatar = responseUploadAvatar.uploaded_files[0]
                currentObject = {
                    ...currentObject,
                    ...{
                        avatar,
                    },
                }
            }
        } catch { }
        console.log('current object', currentObject)

        // put to server
        let response = ''
        if (currentObject.object_id === 0)
            // create object
            response = yield call(createObject, currentObject)
        // update object
        else
            response = yield call(
                updateObjectById,
                currentObject.object_id,
                currentObject
            )

        if (response.error.code === 200) {
            if (currentObject.object_id === 0)
                message.success('Thêm đối tượng thành công')
            else message.success('Cập nhật thông tin đối tượng thành công')

            yield put(actions.action.loadListObject({}))
        } else {
            HandleErrorCode(response.error.code)
            console.log(
                'Save current object call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('Save current object error : ', ex.message)
    }
}

function* saga_DeleteObject(action) {
    try {
        const { objectId } = action.payload
        const response = yield call(deleteObject, objectId)

        if (response.error.code === 200) {
            message.success('Xoá đối tượng thành công')

            yield put(actions.action.loadListObject({}))
        } else {
            HandleErrorCode(response.error.code)
        }
    } catch (ex) {
        console.error('Delete object error : ', ex.message)
    }
}

function* saga_getLinkUrlToBase64(action) {
    try {
        const { lstLink } = action.payload
        console.log('lstlink', lstLink)
        let lstBase64 = []
        for (let i = 0; i < lstLink.length; i++) {
            if (lstLink[i] === '') {
                lstBase64.push('')
            } else {
                let crrlink = yield call(imageToBase64, lstLink[i])
                lstBase64.push(crrlink)
            }

        }
        yield put(actions.action.parseImageLinkToBase64Done(lstBase64))
        console.log('lstBase64', lstBase64)
    } catch (ex) {
        console.error('Delete object error : ', ex.message)
    }
}
function* saga_ChangePageSize(action) {
    try {
        const { pageSize } = action.payload

        yield put(
            actions.action.loadListObject({
                page_number: 1,
                page_size: pageSize,
            })
        )
    } catch (ex) {
        console.error('Change page object size error : ', ex.message)
    }
}

function* saga_ChangeCurrentPage(action) {
    try {
        const { pageIndex } = action.payload

        yield put(actions.action.loadListObject({ page_number: pageIndex }))
    } catch (ex) {
        console.log('Change current object page error : ', ex.message)
    }
}
function* saga_getListObjectQueryByid(action) {
    try {
        const { lst } = action.payload
        const request = yield call(getListObjectQuerybyid, lst)

        if (request.error.code === 200) {
            yield put(actions.action.getListObjectQueryById_done(request.data))
        } else {
            yield put(actions.action.getListObjectQueryById_done([]))
        }
    } catch (ex) {
        console.log('get lisst object by id error : ', ex.message)
    }
}
function* saga_getObjectById(action) {
    try {
        const { id } = action.payload
        const request = yield call(getListObjectQuerybyid, id)
        if (request.error.code === 200) {
            yield put(actions.action.updateCurrentObject(request.data[0]))
        } else {
            yield put(actions.action.updateCurrentObject({}))
        }
    } catch (ex) {
        console.log('get object by id : ', ex.message)
    }
}
function* saga_searchSuggestion(action) {
    try {
        let { textSearch } = action.payload

        const response = yield call(
            getListObjectsByName,
            1,
            10,
            0,
            textSearch
        )

        if (response.error.code === 200) {
            yield put(actions.action.getSuggestionDataDone(response.data))

        } else {
            yield put(actions.action.getSuggestionDataDone([]))
        }
    } catch (ex) {
        console.log('Search suggestion object error : ', ex.message)
    }
}

function* saga_SearchObject(action) {
    try {
        const { begin_time, end_time, type_search } = action.payload
        let page_number = 1
        let page_size = yield select(state => state.object.pageSize)
        let status = yield select(state => state.object._status)
        let textSearch = yield select(state => state.object.textSearch)
        console.log('text search object', action)
        const response = yield call(
            getListObjects,
            page_number,
            page_size,
            status,
            (textSearch),
            begin_time,
            end_time,
            type_search
        )

        if (response.error.code === 200) {
            let objects = response.data
            let total = response.total

            if (objects.length > page_size)
                objects = objects.slice(0, page_size)

            yield put(actions.action.loadListObjectsSuccess(objects))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                    pageIndex: 1,
                })
            )
        } else {
            yield put(actions.action.loadListObjectsSuccess([]))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total: 0,
                    pageIndex: 0,
                })
            )
        }
    } catch (ex) {
        console.log('Search object error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.LOAD_LIST_OBJECTS, saga_LoadListObjects)
    yield takeEvery(actions.type.SAVE_CURRENT_OBJECT, saga_SaveCurrentObject)
    yield takeEvery(actions.type.DELETE_OBJECT, saga_DeleteObject)
    yield takeEvery(actions.type.CHANGE_PAGE_SIZE, saga_ChangePageSize)
    yield takeEvery(actions.type.CHANGE_CURRENT_PAGE, saga_ChangeCurrentPage)
    yield takeEvery(actions.type.GET_OBJECT_BY_ID, saga_getObjectById)
    yield takeEvery(actions.type.PARSE_IMAGE_LINK_TO_BASE64, saga_getLinkUrlToBase64)
    yield takeEvery(actions.type.GET_SUGGESTION_DATA, saga_searchSuggestion)



    yield takeEvery(
        actions.type.GET_LIST_OBJECT_QUERY_BY_ID,
        saga_getListObjectQueryByid
    )
    yield takeEvery(actions.type.SEARCH_OBJECT, saga_SearchObject)
}

export default function* objectsSaga() {
    yield all([fork(listen)])
}
